<app-pan-card [isPageContainer]="true" pageContainerSize="xl" header="Tracking Report Shared" [subheader]="subheader()">
  <app-pan-button leftActions color="primary" variant="text" (click)="back()">Back</app-pan-button>
  @if (isLoading()) {
    <app-pan-blank-slate>
      <app-pan-spinner size="xl"></app-pan-spinner>
      Loading...
    </app-pan-blank-slate>
  } @else {
    <div class="space-y-2">
      @for (log of shareLogs(); track log.sent_at) {
        <app-pan-card class="mb-3">
          <span class="font-bold">{{ formatSentAt(log.sent_at) }}</span> <br/>
          {{ log.sender }} shared this report
        </app-pan-card>
      }
    </div>
  }
</app-pan-card>
